export default {
  uploadNFCSKU: '上传 NFC SKU',
  refreshNSPNFC: '刷新NSP NFC产品',
  refreshPFNFC: '刷新PF NFC产品',
  refreshRFID: '刷新RFID产品',
  refreshWaveRun: '刷新Wave Run',
  updatedTime: '更新时间 ',
  skuHistory: 'SKU 历史'
}
